<template>
  <section class="notifications navbar-notifications">
    <!-- <header class="cardHeader card-header">
      <div class="text-center mb-sm">
        <strong>You have 13 notifications</strong>
      </div>
      <b-button-group id="notification-b-buttons">
        <b-button @click="changeNotificationsTab(1)">Notifications</b-button>
        <b-button @click="changeNotificationsTab(2)">Messages</b-button>
        <b-button @click="changeNotificationsTab(3)">Progress</b-button>
      </b-button-group>
    </header> -->
    <template>
      <b-list-group
        class="listGroup thin-scroll"
        style="height: auto; max-height: 320px"
      >
        <p v-if="dataEws.length === 0" class="mx-auto my-auto">Tidak ada notifikasi</p>
        <b-list-group-item
          v-for="(data, index) in dataEws"
          class="listGroupItem border-bottom"
          :key="index"
        >
          <!-- <span class="notificationIcon thumb-sm">
            <img
              class="rounded-circle"
              src="../../../assets/people/a3.jpg"
              alt="woman"
            />
          </span> -->
          <p class="m-0 overflow-hidden">
            <span class="notif-line-clamp">
              {{ data.isi_notifikasi }}
            </span>
            <time class="help-block m-0">{{
              formatDate(data.createdAt, 'DD/MM/YYYY HH:mm')
            }}</time>
          </p>
        </b-list-group-item>
      </b-list-group>
    </template>
    <!-- <NewNotifictionsList v-if="newNotifications" /> -->
    <!-- <NotifictionsList /> -->
    <!-- <Messages v-else-if="notificationsTabSelected === 2" /> -->
    <!-- <Progress v-else-if="notificationsTabSelected === 3" /> -->
    <!-- <NotifictionsList v-else/> -->
    <!-- <footer class="cardFooter text-sm card-footer">
      <span class="fs-mini">Synced at: 21 Apr 2014 18:36</span>
      <b-button
        variant="link"
        @click="loadNotifications"
        :class="{disabled: isLoad, 'btnNotificationsReload btn-xs float-end py-0': true}"
      >
        <span v-if="isLoad"><i class="la la-refresh la-spin" /> Loading...</span>
        <i v-else class="la la-refresh" />
      </b-button>
    </footer> -->
  </section>
</template>

<style>
.notif-line-clamp {
  display: -webkit-box;
  line-clamp: 2;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.notif-line-clamp:hover {
  line-clamp: 100;
  -webkit-line-clamp: 100;
}
</style>

<script>
import Vue from 'vue'

import NotifictionsList from './NotificationsDemo/NotificationsList'
import NewNotifictionsList from './NotificationsDemo/NewNotificationsList'
import Messages from './NotificationsDemo/Messages'
import Progress from './NotificationsDemo/Progress'
import axios from 'axios'
import { formatDate } from '../../helper/helpernew'

export default {
  name: 'Notification',
  components: {
    NotifictionsList,
    NewNotifictionsList,
    Messages,
    Progress,
  },
  data() {
    return {
      notificationsTabSelected: 1,
      newNotifications: null,
      isLoad: false,
      baseapiPengendalian: localStorage.getItem('baseapiPengendalian'),
      user: JSON.parse(localStorage.getItem('userPengendalian')),
      dataEws: [],
    }
  },
  mounted() {
    this.loadDataEws()
  },
  methods: {
    formatDate,

    loadDataEws() {
      axios
        .get(
          this.baseapiPengendalian + `api/ews_history?filter=id_user,=,${this.user.id}`,
          {
            headers: {
              Authorization: `Bearer ` + this.user.accessToken,
            },
          }
        )
        .then((res) => {
          this.dataEws = res.data.data
        })
    },
  },
}
</script>

<style src="./Notifications.scss" lang="scss" />
